import React from "react";
import styled from "styled-components";

const ProductImages = ({ images = [{ url: "" }] }) => {
  return (
    <Wrapper>
      <div className="frame">
        <img src={images} alt="produkt" className="main" />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .frame {
    background: var(--clr-paper);
    border: 1px solid var(--clr-divider);
    border-radius: var(--radius-lg);
    padding: 0.5rem;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    line-height: 0;
  }
  .main {
    width: 100%;
    height: auto;
    max-height: 560px;
    object-fit: contain;
    border-radius: var(--radius);
    display: block;
  }
`;

export default ProductImages;
